// Reusable tier badge — central place for tier coloring.
//
// Tiers in site_details are lowercase (critical/high/medium/low) per the
// diagnostic import migration. Ticket tiers are capitalized in the schema
// and include 'AMP'. This component accepts any casing.
//
// Optional `rank` prop appends "#23" after the tier name when present.
// Optional `size` prop = 'sm' (default) or 'lg' for hero displays.

const TIER_STYLE = {
  critical: { bg: '#FCEBEB', color: '#A32D2D', dot: '🔴', label: 'Critical' },
  high:     { bg: '#FAEEDA', color: '#854F0B', dot: '🟡', label: 'High' },
  medium:   { bg: '#EAF3DE', color: '#3B6D11', dot: '🟢', label: 'Medium' },
  low:      { bg: '#F1EFE8', color: '#5F5E5A', dot: '⚪', label: 'Low' },
  amp:      { bg: '#F3E8FF', color: '#6B21A8', dot: '🟣', label: 'AMP' },
}

export default function TierBadge({ tier, rank, size = 'sm' }) {
  if (!tier) return null
  const key = String(tier).toLowerCase()
  const t = TIER_STYLE[key]
  if (!t) return null

  const dim = size === 'lg'
    ? { fontSize: 13, padding: '4px 10px', borderRadius: 12 }
    : { fontSize: 11, padding: '2px 7px', borderRadius: 10 }

  return (
    <span style={{
      ...dim,
      background: t.bg,
      color: t.color,
      fontWeight: 500,
      whiteSpace: 'nowrap',
      display: 'inline-flex',
      alignItems: 'center',
      gap: 4,
    }}>
      <span>{t.dot}</span>
      <span>{t.label}{rank != null && ` #${rank}`}</span>
    </span>
  )
}

// Export the style map so other pages can use the colors directly
// (e.g. for tier filter buttons).
export { TIER_STYLE }
